import { useQuery } from '@tanstack/react-query'

import apiClient from '@app/config/axios.config'
import { Endpoint } from '@app/config/endpoints'

export type Region = {
  region: string
  region_name: string
  group_name: string
  max_x: number
  max_y: number
  min_x: number
  min_y: number
}

export type RegionsResponse = Region[]

export const fetchRegions = async (): Promise<RegionsResponse> => {
  const response = await apiClient.get<RegionsResponse>(Endpoint.getRegions)
  return response.data
}

export function useFetchRegions() {
  return useQuery({
    queryKey: ['regions'],
    queryFn: fetchRegions,
  })
}
